import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

import { OrgChartResponse } from 'src/app/modules/org-profile/models/org.models';

/**
 * Organization hierarchy.
 *
 * Backs both the employee profile's "Standard View" team list and the
 * organization tree — the API returns the whole reporting hierarchy in one
 * call, so both screens read the same response and shape it differently.
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private http: HttpClient) {}

  /** GET /user/org-chart/ */
  getOrgChart(): Observable<OrgChartResponse> {
    return this.http.get<OrgChartResponse>(`${environment._url}/user/org-chart/`);
  }
}
